import { useMemo } from 'react';
import plateRecognitionContext from 'features/eiq-secure/stores/license-plate-recognition-context';
import configurationStore from 'common/stores/configuration/configuration.store';
import userAuthStore from 'common/stores/user-auth/user-auth.store';
import { IUseDefaultAdmitValuesProps } from './use-default-admit-values.types';
import { toDisplayLicenseState } from 'features/eiq-secure/heplers/license-plate-recognition-state';

export const useDefaultAdmitValues = ({ currentGuest }: IUseDefaultAdmitValuesProps) => {
  const lprContext = plateRecognitionContext.data;
  const configuration = configurationStore.configuration;
  const guestLicensePlate = currentGuest?.carLicensePlates.find((i) => i.isPrimary);

  const defaultGate = useMemo(() => {
    if (lprContext) {
      return lprContext.gate;
    }
    return userAuthStore.defaultGate || undefined;
  }, [lprContext]);

  const defaultLicensePlate = useMemo(() => {
    if (lprContext) {
      return lprContext.licensePlate;
    }

    return guestLicensePlate?.number || undefined;
  }, [lprContext, guestLicensePlate]);

  const defaultLicenseState = useMemo(() => {
    if (lprContext) {
      return toDisplayLicenseState(lprContext.licenseState);
    }

    return guestLicensePlate?.state || configuration?.default.defaultLicenseState || undefined;
  }, [lprContext, configuration, guestLicensePlate]);

  const camera = useMemo(() => {
    return lprContext?.camera;
  }, [lprContext]);

  return { defaultGate, defaultLicensePlate, defaultLicenseState, image: lprContext?.image, camera: camera };
};
